import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { User } from '@supabase/supabase-js';

import { patchUserMetaData } from 'src/api/userService/requests';
import { PatchUserMetaDataSuccessResponse } from 'src/api/userService/types';
import { UserDetailsPartial } from 'src/auth/types';

import { queryRetry } from '../query-retry';

export const usePatchUserMetaData = () =>
    useMutation<
        User | PatchUserMetaDataSuccessResponse | null,
        AxiosError,
        { metadata: UserDetailsPartial }
    >({
        mutationFn: ({ metadata }) => patchUserMetaData(metadata),
        retry: queryRetry,
    });
